module.exports = __webpack_public_path__ + "img/folder.49ede2b8.svg";